import { mergeClasses } from 'minimal-shared/utils'

import { useTheme } from '@mui/material/styles'

import { NavList } from './nav-list'
import { Nav, NavUl, NavLi, NavSubheader } from '../components'
import { navSectionClasses, navSectionCssVars } from '../styles'

export function NavSectionVertical({
  sx,
  data,
  render,
  className,
  slotProps,
  enabledRootRedirect,
  cssVars: overridesVars,
  ...other
}) {
  const theme = useTheme()

  const cssVars = { ...navSectionCssVars.vertical(theme), ...overridesVars }

  return (
    <Nav
      className={mergeClasses([navSectionClasses.vertical, className])}
      sx={[{ ...cssVars }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...other}
    >
      <NavUl sx={{ flex: '1 1 auto', gap: 'var(--nav-item-gap)' }}>
        {data.map((group) => (
          <Group
            key={group.subheader ?? group.items[0].title}
            subheader={group.subheader}
            items={group.items}
            render={render}
            slotProps={slotProps}
            enabledRootRedirect={enabledRootRedirect}
          />
        ))}
      </NavUl>
    </Nav>
  )
}

function Group({ items, render, subheader, slotProps, enabledRootRedirect }) {
  const renderContent = () => (
    <NavUl sx={{ gap: 'var(--nav-item-gap)' }}>
      {items.map((list) => (
        <NavList
          key={list.title}
          data={list}
          render={render}
          depth={1}
          slotProps={slotProps}
          enabledRootRedirect={enabledRootRedirect}
        />
      ))}
    </NavUl>
  )

  return (
    <NavLi>
      {subheader ? (
        <>
          <NavSubheader data-title={subheader} sx={slotProps?.subheader}>
            {subheader}
          </NavSubheader>
          {renderContent()}
        </>
      ) : (
        renderContent()
      )}
    </NavLi>
  )
}
